export enum ETheme {
    Default = 'Default',
    Blue = 'Blue',
    Red = 'Red',
    Green = 'Green',
    Yellow = 'Yellow',
    Gray = 'Gray',
    LightGray = 'LightGray',
    White = 'White'
}